import { isAllowed } from '../Apollo/allower';
import permissions from '../Apollo/permissions';

// When using this hook, please pass the per(permission) which can map the key from permissions
const useMrAllower = per => {
  return isAllowed(permissions[per]);
};

export default useMrAllower;
